<template>

        <!-- Transacciones -->
        <div class="section mt-4">
            <div class="section-heading">
              <h2 class="title">Historial</h2>
              <router-link :to="{ name: 'history' }" class="link">
                Ver Todas
              </router-link>
            </div>

            <div class="card">
              <ul class="listview image-listview flush">
                <li class="active placeholder-glow" v-if="loading == true">
                  <a class="item placeholder col-12">
                    <div class="icon-box bg-secondary">
                      <p class="placeholder image-block imaged w48"></p>
                    </div>
                    <div class="in">
                      <div>
                        <div class="mb-05">
                          <strong class="placeholder col-12"></strong>
                        </div>
                        <div class="text-small mb-05 placeholder col-12"> <b class="placeholder col-12"></b></div>
                        <div class="text-xsmall placeholder col-12"></div>
                      </div>
                      <span class="badge badge-primary badge-empty placeholder col-12"></span>
                    </div>
                  </a>
                </li>
                <li class="active placeholder-glow" v-if="loading == false && records.length == 0">
                  <a class="item col-12 placeholder">
                    <div class="icon-box bg-secondary">
                      <p class="placeholder image-block imaged w48"></p>
                    </div>
                    <div class="in">
                      <div>
                        <div class="mb-05">
                          <strong class="col-12">Buscando transacciones</strong>
                        </div>
                        <div class="text-small mb-05 col-12">No encontramos Txs, intenta en un rato. <b class="col-12"></b></div>
                        <div class="text-xsmall col-12">intenta en un rato.</div>
                      </div>
                      <span class="badge badge-primary badge-empty placeholder col-12"></span>
                    </div>
                  </a>
                </li>
                <li v-for="(tx, i_tx) in records" v-bind:key="'i_tx-' + i_tx" v-else>
                  <history-item-card-section :tx="tx" />
                </li>
            </ul>
          </div>
        </div>
        <!-- * Transacciones -->

</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'HomeView',
  data() {
    return {
    //   networks: [],
    //   currencies: [],
      records: [],
      loading: true,
      form: {
        network: 0,
        asset: 0,
      }
    };
  },
  matches: {
    'form.network'() {
      this.form.asset = 0;
    }
  },
  computed: {
  },
  async mounted() {
    this.$root.loadBackButtom();
    this.$root.loadInputs();
    await this.loadTxs()
  },
  methods: {
    ...mapActions(['v1_historyList']),
    
    async loadTxs() {
      console.log('loadTxs')
      this.loading = true;
      const records = await this.v1_historyList()
      console.log('records', records)
      if (records.code == undefined) {
          this.records = records
      }
      this.loading = false;
    }
  },
}
</script>
